<div app-theme class="nft-modal-container p-15px d-flex flex-column">
  <div class="fs-20px">
    Burn {{ balanceEntryResponse.ProfileEntryResponse?.Username }} DAO Coins
  </div>
  <div class="pt-15px">
    Your Balance:
    {{
      globalVars.hexNanosToUnitString(balanceEntryResponse.BalanceNanosUint256)
    }}
    {{ balanceEntryResponse.ProfileEntryResponse?.Username }} DAO Coins
  </div>
  <div class="input-group py-15px">
    <div class="input-group-prepend">
      <span class="input-group-text">Amount To Burn</span>
    </div>
    <input
      [(ngModel)]="amountToBurn"
      (ngModelChange)="updateValidationErrors()"
      class="form-control fs-15px text-right d-inline-block"
      type="number"
      min="0"
      placeholder="0"
      [disabled]="burningDAOCoin"
    />
  </div>
  <button
    class="btn btn-primary font-weight-bold br-12px"
    style="height: 36px; width: 180px; line-height: 15px"
    (click)="burnDAOCoin()"
    [disabled]="burningDAOCoin || validationErrors.length"
  >
    Burn
  </button>
  <ng-container *ngIf="validationErrors.length">
    <div *ngFor="let validationError of validationErrors" class="pt-5px fc-red">
      {{ validationError }}
    </div>
  </ng-container>
  <div class="fc-red pt-5px" *ngIf="backendErrors">
    {{ backendErrors }}
  </div>
</div>
